"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResetConsent = exports.GDPR_CONSENT_COOKIE_EXPIRE_DATE = exports.GDPR_CONSENT_COOKIE_NAME = void 0;
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
var components_1 = require("@theme-ui/components");
var core_1 = require("@theme-ui/core");
var mdx_1 = require("@theme-ui/mdx");
var react_1 = require("react");
var react_cookie_1 = require("react-cookie");
var helpers_1 = require("../../helpers");
exports.GDPR_CONSENT_COOKIE_NAME = "gdpr-cookie-consent";
exports.GDPR_CONSENT_COOKIE_EXPIRE_DATE = new Date();
exports.GDPR_CONSENT_COOKIE_EXPIRE_DATE.setMonth(exports.GDPR_CONSENT_COOKIE_EXPIRE_DATE.getMonth() + 12);
var CookieConsent = function (_a) {
    var _b = _a.message, message = _b === void 0 ? "Ce site utilise des cookies à des fins statistiques." : _b, _c = _a.acceptLabel, acceptLabel = _c === void 0 ? "Accepter" : _c, _d = _a.declineLabel, declineLabel = _d === void 0 ? "Décliner" : _d, acceptButtonRender = _a.acceptButtonRender, declineButtonRender = _a.declineButtonRender, children = _a.children;
    var _e = (0, react_cookie_1.useCookies)([exports.GDPR_CONSENT_COOKIE_NAME]), cookies = _e[0], setCookie = _e[1];
    var _f = (0, react_1.useState)(false), showConsent = _f[0], setShowConsent = _f[1];
    var displayConsent = (0, react_1.useCallback)(function () {
        setShowConsent(true);
        window.removeEventListener("mousemove", displayConsent);
        window.removeEventListener("touchmove", displayConsent);
    }, []);
    (0, react_1.useEffect)(function () {
        if (!cookies[exports.GDPR_CONSENT_COOKIE_NAME]) {
            window.addEventListener("mousemove", displayConsent);
            window.addEventListener("touchmove", displayConsent);
            return function () {
                window.removeEventListener("mousemove", displayConsent);
                window.removeEventListener("touchmove", displayConsent);
            };
        }
        return undefined;
    }, [cookies, displayConsent]);
    var accept = (0, react_1.useCallback)(function () {
        setCookie(exports.GDPR_CONSENT_COOKIE_NAME, "accept", {
            expires: exports.GDPR_CONSENT_COOKIE_EXPIRE_DATE,
        });
        setShowConsent(false);
    }, [setCookie]);
    var decline = (0, react_1.useCallback)(function () {
        setCookie(exports.GDPR_CONSENT_COOKIE_NAME, "refuse", {
            expires: exports.GDPR_CONSENT_COOKIE_EXPIRE_DATE,
        });
        setShowConsent(false);
    }, [setCookie]);
    if (!showConsent) {
        return null;
    }
    return ((0, core_1.jsx)("div", { sx: {
            position: (0, helpers_1.responsive)({
                xs: "sticky",
                md: "fixed",
            }),
            bottom: 0,
            padding: 3,
            right: 0,
            width: (0, helpers_1.responsive)({ xs: "auto", md: "320px" }),
            marginLeft: (0, helpers_1.responsive)({ xs: 0, md: "auto" }),
            zIndex: 1,
        } }, children((0, core_1.jsx)("div", { sx: { textAlign: "center", position: "relative" } },
        (0, core_1.jsx)(mdx_1.Themed.p, null,
            (0, core_1.jsx)("strong", null, message)),
        (0, core_1.jsx)(components_1.Grid, null,
            declineButtonRender ? (declineButtonRender(declineLabel, decline)) : ((0, core_1.jsx)(components_1.Button, { onClick: decline }, declineLabel)),
            acceptButtonRender ? (acceptButtonRender(acceptLabel, accept)) : ((0, core_1.jsx)(components_1.Button, { onClick: accept }, acceptLabel)))))));
};
var useResetConsent = function () {
    var _a = (0, react_cookie_1.useCookies)([exports.GDPR_CONSENT_COOKIE_NAME]), setCookie = _a[1];
    var resetConsent = (0, react_1.useCallback)(function () {
        setCookie(exports.GDPR_CONSENT_COOKIE_NAME, "", {
            expires: exports.GDPR_CONSENT_COOKIE_EXPIRE_DATE,
        });
    }, [setCookie]);
    return {
        resetConsent: resetConsent,
        label: "Préférences cookies",
    };
};
exports.useResetConsent = useResetConsent;
exports.default = (0, react_1.memo)(CookieConsent);
